import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Assistant Gradient Icon from Figma
 * @link [Figma](https://www.figma.com/design/OcHNCErLKZZwfVXAoIoRas/%F0%9F%8F%A6-Bank-Reconciliation?node-id=8589-527807)
 * */

const AssistantGradientIcon = props => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_assistant_gradient)"><path d="M11.5 10.4H9.3M10.4 11.5V9.3M2.7 1.6H0.5M1.6 2.7L1.6 0.5M6.05211 0.708444L7.09218 4.86873C7.097 4.88798 7.11202 4.90301 7.13127 4.90782L11.2916 5.94789C11.3458 5.96145 11.3458 6.03855 11.2916 6.05211L7.13127 7.09218C7.11202 7.097 7.097 7.11202 7.09218 7.13127L6.05211 11.2916C6.03855 11.3458 5.96145 11.3458 5.94789 11.2916L4.90782 7.13127C4.90301 7.11202 4.88798 7.097 4.86873 7.09218L0.708444 6.05211C0.654195 6.03855 0.654195 5.96145 0.708444 5.94789L4.86873 4.90782C4.88798 4.90301 4.90301 4.88798 4.90782 4.86873L5.94789 0.708444C5.96145 0.654195 6.03855 0.654195 6.05211 0.708444Z" stroke="url(#paint0_linear_assistant_gradient)" strokeLinecap="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <linearGradient id="paint0_linear_assistant_gradient" x1="0" y1="12" x2="12" y2="0" gradientUnits="userSpaceOnUse"><stop offset="0.1" stopColor="#959BC9" /><stop offset="0.39" stopColor="#AC7CFF" /><stop offset="0.62" stopColor="#10B981" /><stop offset="0.89" stopColor="#F0AE79" /></linearGradient>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <defs>{t1}<clipPath id="clip0_assistant_gradient"><rect width="12" height="12" fill="white" /></clipPath></defs>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <Svg width={12} height={12} {...props}>{t0}{t2}</Svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default AssistantGradientIcon;